import {
  patch_lifecycle_default
} from "../../chunk-G2QGH4BR.mjs";

// src/components/lifecycle/index.ts
var metaKey = Symbol();
var indexKey = Symbol();
var lifecycleMethods = {
  onMount: runMount,
  onUpdate: runUpdate,
  onDestroy: runDestroy
};
function lifecycle_default(component, cur = {}) {
  const meta = component[metaKey];
  const index = component[indexKey];
  if (meta) {
    if (index === void 0) {
      meta.push(0, cur);
    } else {
      component[indexKey] += 2;
      const prev = meta[index + 1];
      prev.onMount = cur.onMount;
      prev.onDestroy = cur.onDestroy;
      if (prev.onUpdate !== cur.onUpdate) {
        meta[index] = 1;
        prev.onUpdate = cur.onUpdate;
      }
    }
  } else {
    patch_lifecycle_default(component, lifecycleMethods);
    component[metaKey] = [0, cur];
  }
}
function runMount() {
  const meta = this[metaKey];
  if (meta) {
    this[indexKey] = 0;
    for (let i = 1; i < meta.length; i += 2) {
      const handlers = meta[i];
      if (handlers.onMount) {
        handlers.onMount();
      }
    }
  }
}
function runUpdate() {
  const meta = this[metaKey];
  if (meta) {
    this[indexKey] = 0;
    for (let i = 0; i < meta.length; i += 2) {
      if (meta[i]) {
        meta[i] = 0;
        const handlers = meta[i + 1];
        if (handlers.onUpdate) {
          handlers.onUpdate();
        }
      }
    }
  }
}
function runDestroy() {
  const meta = this[metaKey];
  if (meta) {
    for (let i = 1; i < meta.length; i += 2) {
      const handlers = meta[i];
      if (handlers.onDestroy) {
        handlers.onDestroy();
      }
    }
  }
}
export {
  lifecycle_default as default
};
